import React from 'react';
import { Stack } from '@moda/om';
import { hrefFor } from '../../routers';
import { Link } from '../Link';
import { useUser } from '../../hooks/useUser';
import { UserRewardStatus } from '../../constants';
import { UserStatusLevel } from '../../constants';

import './AccountLinks.scss';

export const AccountLinks: React.FC = () => {
  const {
    user: { userLoyaltyStatus, statusLevel }
  } = useUser();

  return (
    <Stack className="AccountLinks" space={4}>
      <Link className="AccountLinks__link" to={hrefFor.AccountSettings()} title="Settings">
        Settings
      </Link>

      <Link className="AccountLinks__link" to={hrefFor.AccountOrderHistory()} title="Order History">
        Order History
      </Link>

      <Link className="AccountLinks__link" to={hrefFor.AccountOpenItems()} title="Open Items">
        Open Items
      </Link>

      <Link className="AccountLinks__link" to={hrefFor.AccountShipments()} title="Shipments">
        Shipments
      </Link>

      <Link className="AccountLinks__link" to={hrefFor.AccountReturns()} title="Returns">
        Returns
      </Link>

      <Link className="AccountLinks__link" to={hrefFor.AccountSiteCredits()} title="Site Credits">
        Site Credits
      </Link>

      {userLoyaltyStatus === UserRewardStatus.Enrolled && statusLevel !== UserStatusLevel.Employee && (
        <Link className="AccountLinks__link" to={hrefFor.AccountRewards()} title="M'O Rewards">
          M'O Rewards
        </Link>
      )}

      <Link className="AccountLinks__link" to={hrefFor.LogoutPage()} title="Sign Out">
        Sign Out
      </Link>

      {userLoyaltyStatus === UserRewardStatus.NotEnrolled &&
        statusLevel !== UserStatusLevel.Employee && (
          <Link
            className="AccountLinks__link"
            to={hrefFor.AccountRewards()}
            title="Join Rewards Program"
          >
            Join Rewards Program
          </Link>
        )}
    </Stack>
  );
};
